import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIntercom24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconIntercom24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.5 21.464 14.4 20H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v15zM18.5 7v12.872l-3.595-1.285-.245-.087H7A1.5 1.5 0 0 1 5.5 17V7A1.5 1.5 0 0 1 7 5.5h10A1.5 1.5 0 0 1 18.5 7M8.416 14.376a.75.75 0 0 0-.832 1.248L8 15l-.416.624h.001l.003.002.007.005.02.014.073.045q.094.058.26.15c.221.122.537.282.928.441.778.317 1.876.643 3.124.643s2.347-.326 3.124-.643a9 9 0 0 0 1.187-.59l.073-.046.021-.014.007-.005.003-.001.001-.001L16 15l.416.624a.75.75 0 0 0-.831-1.249l-.001.001-.009.006-.046.029a7.4 7.4 0 0 1-.971.482c-.663.27-1.564.53-2.558.53s-1.895-.26-2.557-.53a7.4 7.4 0 0 1-.972-.482l-.046-.03zm0 0L8 15zm-.001 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIntercom24);
